<script>
export let currentRoute;


import { onMount } from 'svelte';


import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import Form from 'components/forms/views/form/spring-hockey-free-agent/Form.svelte';


import SvelteSeo from 'svelte-seo';



const forms_api_url = app_.env.FORMS_API_URL;



let successfully_submitted = false;



// async function getSeasonInstance() {

// 	const url = `${forms_api_url}/_data/season-instances/${currentRoute.namedParams.season_instance_id}`;

// 	const resp = await fetch(url, {
// 		method: 'GET',	
// 	});

// 	const result = await resp.json();

// 	if (!resp.ok) {
// 		throw new Error(result.detail);
// 	}

// 	return result;

// }


// let promise = getSeasonInstance();

</script>


<style>

</style>


<SvelteSeo
	title='Spring Hockey Free Agent Form | AHG Forms'
	description='Spring Hockey Free Agent Form!'
/>



<!-- {#await promise}

<Loading />

{:then season_instance} -->

<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Spring Free Agent Form: 2023<!-- {season_instance.seasons_sc.name}
				{#if season_instance.year_start === season_instance.year_end}
				(season_instance.year_start)
				{:else}
				(season_instance.year_start - season_instance.year_end)
				{/if} -->
			</p>

		</div>

	</div>
	
</section>


<section class="section skinny-section">

	<div class="container">

		{#if successfully_submitted}

		<MsgCard msg_show={true} msg_text={"Thanks for submitting! You will be contacted by a team if you are needed!"} msg_type={'error'} msg_forever={true} />

		{:else}

		<MsgCard msg_show={true} msg_text={'By filling out this form you will make your child’s name available to AHG coaches for spring hockey. Coaches may contact you to become a part of their spring team. If you have any questions please don’t hesitate to contact our office at 506-855-0414.'} msg_type={'error'} msg_forever={true} />

		<div class="card form-card">

			<div class="card-content">

				<!-- <Form {season_instance} /> -->
				<Form bind:successfully_submitted />

			</div>

		</div>

		{/if}

	</div>

</section>

<!-- {:catch error}

<section class="section skinny-section">

	<div class="container is-fullwidth">

		<MsgCard msg_show={true} msg_text={error.detail} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}

 -->
